import { buildCpiTree } from './cpi-tree.js';
import { parseCuFromLogs, attachCuToTree, buildCuBreakdown } from './cu-parser.js';
import { buildAccountDeltas } from './account-diff.js';
export * from './types.js';
export { buildCpiTree } from './cpi-tree.js';
export { parseCuFromLogs, attachCuToTree, buildCuBreakdown } from './cu-parser.js';
export { buildAccountDeltas } from './account-diff.js';
export { decodeInstruction, decodeSystemInstruction, decodeTokenInstruction, decodeComputeBudgetInstruction } from './decoders/index.js';
export function decodeTransaction(input) {
    const { signature, meta, transaction, slot, blockTime } = input;
    const cpiTree = buildCpiTree(transaction, meta);
    const { perInstruction, totalConsumed, limit } = parseCuFromLogs(meta.logMessages);
    attachCuToTree(cpiTree, perInstruction);
    const cuBreakdown = buildCuBreakdown(cpiTree, totalConsumed, limit);
    const accountDeltas = buildAccountDeltas(transaction, meta);
    return {
        signature,
        slot,
        timestamp: blockTime,
        fee: meta.fee,
        success: meta.err === null,
        cpiTree,
        accountDeltas,
        cuBreakdown,
        raw: { meta, transaction },
    };
}
//# sourceMappingURL=index.js.map